export const SEARCH_RESULT = 'search_result';
export const FLIGHT_MATRIX = 'flight_matrix';
export const EXCHANGE_CART = 'exchange_cart';

const getTripLabel = (tripCount, origin, destination, scope) => {
  if (typeof tripCount === 'number') {
    if (scope === SEARCH_RESULT) {
      return I18n.t('components.ibe.results.trip_title', {
        count: tripCount + 1,
        origin,
        destination,
      });
    } else if ([FLIGHT_MATRIX, EXCHANGE_CART].includes(scope)) {
      return I18n.t('components.ibe.results.trip_number_with_route', {
        number: tripCount,
        origin,
        destination,
      });
    }
  }

  return `${origin} - ${destination}`;
};

export default getTripLabel;
